
import 'ol/ol.css';
import 'ol-ext/dist/ol-ext.css'
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import { get as getProjection } from 'ol/proj';
import { fromLonLat } from 'ol/proj';
import Colorize from 'ol-ext/filter/Colorize';

import ImageLayer  from 'ol/layer/Image';
import Static from 'ol/source/ImageStatic';

import { bbox } from 'ol/loadingstrategy';
import { Style, Fill, Stroke, Circle } from 'ol/style';
import { transformExtent } from 'ol/proj';

import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON';

import DragZoom from 'ol/interaction/DragZoom';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';


      proj4.defs("EPSG:3067", "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs");
      proj4.defs("EPSG:4326", "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs");
      // proj4.defs("EPSG:25833", "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs");
      register(proj4);

      var map;
      var projection = getProjection('EPSG:3857');
      var dataProjection = getProjection('EPSG:4326');
      var dataProjectionFI = getProjection('EPSG:3067');
      
      var llno = fromLonLat([3.5, 57.5]);
      var urno = fromLonLat([32, 72])
      
      var llfi = fromLonLat([19, 59]);
      var urfi = fromLonLat([32, 70.1])

      var imageLayer = new ImageLayer();
      
      var parser = new WMTSCapabilities();
      
      
      let region10k;
      let region100k;
      let region250k;
      let region1000k;
      let region4500k;
      
      let layer = 'dsm';
      let layerByCountry = 'DSM';
      let collections = 'DSM_NO,DSM_FI';
      
      let fi = true;
      let no = true;
      
      
      $("#showBorder").button();
      
      $("#showBorder").on('click', function() {
          let buttonText = $("#showBorder").prop("value");
          if (buttonText === "Hide Border") {
              $("#showBorder").prop("value", "Show Border");
              removeBorder();
          }
          if (buttonText === "Show Border") {
              $("#showBorder").prop("value", "Hide Border");
              addBorder();
          }        
      });
      
      $("#sliderCoverage").on('input', function () {
          imageLayer.setOpacity(parseFloat($(this).val()));
      });
      
      $("input[type='radio']").checkboxradio({
          classes: {
              "ui-checkboxradio": "highlight"
          }
      });
      
      $("#radio-1a").on('change', function () {
          layer = 'dtm';
          layerByCountry = 'DTM';
          updateCollections();
      });
      
      $("#radio-2a").on('change', function () {
          layer = 'dsm';
          layerByCountry = 'DSM';
          updateCollections();
      });
      
      $("#checkbox-1").change(function () {
          updateCollections();
      });
      
      $("#checkbox-2").change(function () {
          updateCollections();
      });   
      
      $("#startDownload").button();
      
      $("#downloadFormat").selectmenu({ width : 'auto'});
      

      fetch('/geoe3/wmts/').then(function(response) {
          return response.text();
      }).then(function(text) {
         var resultfi = parser.read(text);
         var optionsfi = optionsFromCapabilities(resultfi, {
             // layer: 'maastokartta',
             layer: 'taustakartta',
             matrixSet: 'WSG84_Pseudo-Mercator',
    	     projection: 'EPSG:3857'
         });

         var backgroundfi = new TileLayer({
             opacity: 1,
             source: new WMTS(optionsfi),
             extent: [llfi[0], llfi[1], urfi[0], urfi[1]]
         });


          fetch('https://cache.kartverket.no/capabilities/topo4/WMTSCapabilities.xml?version=1.0.0&service=wmts&request=getcapabilities').then(function(response) {
          
              return response.text();
          }).then(function(text) {
             var resultno = parser.read(text);
             var optionsno = optionsFromCapabilities(resultno, {
                 layer: 'topo4',
                 // layer: 'norgeskart_bakgrunn2',
                 // layer: 'topo4',
                 // layer: 'toporaster4',
                 matrixSet: 'googlemaps',
            	     projection: 'EPSG:3857'
             });

             var backgroundno = new TileLayer({
                 opacity: 1,
                 source: new WMTS(optionsno),
                 extent: [llno[0], llno[1], urno[0], urno[1]]
             })
             
             map = new Map({
               target: 'map',
            	   projection: projection,
            	   layers: [backgroundfi, backgroundno, imageLayer],
            	   view: new View({
            	     center: fromLonLat([22, 65]),
            	     zoom: 5
            	   })
             });
             
             map.getInteractions().forEach((interaction) => {
                  if (interaction instanceof MouseWheelZoom) {
                        interaction.setActive(false);
                  }
             });
             
             // var enhance = new Colorize({ operation:'grayscale' });
             // backgroundfi.addFilter(enhance);
             // backgroundno.addFilter(enhance);
             
             // map.on('moveend', updateCoverageLayer);
             
             var coverageUpdateAlreadyDone = false;
             
             map.on('movestart', onMoveStart);
             map.on('moveend', onMoveEnd);

             function onMoveStart(evt) {
                 coverageUpdateAlreadyDone = false;
                 // console.log("Move start!");
             }

             function onMoveEnd(evt) {

                  setTimeout(function () {
                      if (!coverageUpdateAlreadyDone) {
                          updateCoverageLayer();
                          coverageUpdateAlreadyDone = true;
                          // console.log("updateCoverageLayer done!");
                      }
                  }, 500);
             }
             
             region10k = createRegionLayer('valtakunta', 10, 2, 0, 10);
             region100k = createRegionLayer('valtakunta', 100, 2, 10, 50);
             region250k = createRegionLayer('valtakunta', 250, 2, 50, 200);
             region1000k = createRegionLayer('valtakunta', 1000, 1, 200, 500);
             region4500k = createRegionLayer('valtakunta', 4500, 1, 500, 1000000);

             map.addLayer(region10k);
             map.addLayer(region100k);
             map.addLayer(region250k);
             map.addLayer(region1000k);
             map.addLayer(region4500k);
         
          });

      });
      
      
    function updateCoverageLayer() {
        // console.log("In updateCoverageLayer!");
        let currentExtent = map.getView().calculateExtent(map.getSize());
        // console.log('currentExtent: ' + currentExtent)
        // var targetExtent = transformExtent(currentExtent, projection.getCode(), dataProjection.getCode());
        
        // let minx = targetExtent[0];
        // let miny = targetExtent[1];
        // let maxx = targetExtent[2];
        // let maxy = targetExtent[3];
        let minx = currentExtent[0];
        let miny = currentExtent[1];
        let maxx = currentExtent[2];
        let maxy = currentExtent[3];
        let mapsize = map.getSize();
        
        // Let's extend the imageLayer by 200 pixels to every direction to accomadate for reprojection effects
        var width = Math.round(mapsize[0]);
        var height = Math.round(mapsize[1]);
        var res = (maxx - minx) / width;
        
        width += 300;
        height += 300;
        var ext = 150 * res;
        
        minx = minx - ext;
        miny = miny - ext;
        maxx = maxx + ext;
        maxy = maxy + ext;
        
        var extendedExtent = [minx, miny, maxx, maxy]
        
        var source = new Static({
                url: "/geoe3/" + layer + "/search?f=png" 
                     + "&collections=" + collections + "&subset=x(" + minx + ":" + maxx + "),y(" + miny + ":" + maxy + ")"
		     + "&scale-size=x(" + width + "),y(" + height + ")",
                projection: projection.getCode(),
                imageExtent: extendedExtent,
                // imageExtent: currentExtent,
        });
        imageLayer.setSource(source);
        imageLayer.getSource().refresh();
        // imageLayerfi.setOpacity(parseFloat($("#sliderCoverage").val()));
        
    }
    

    function createRegionLayer(level, scale, lineWidth, minRes, maxRes) {


        let region = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON({featureProjection:projection.getCode(), dataProjection: dataProjectionFI.getCode()}),
                url: function (extent) {
                    let fcName = level + '_' + scale + 'k';
                    var targetExtent = transformExtent(extent, projection.getCode(), dataProjectionFI.getCode());
                    return 'https://vm0160.kaj.pouta.csc.fi/geoserver/ogc/features/collections/' + fcName + 
                    '/items?bbox=' + targetExtent.join(',') +
                    "&bbox-crs=http://www.opengis.net/def/crs/EPSG/0/3067&crs=http://www.opengis.net/def/crs/EPSG/0/3067" +
                    '&f=json&limit=100000';
                },
                strategy: bbox
            }),
            style: new Style({
                // fill: new Fill({
                //     color: 'rgba(0, 190, 255, 0.1)'
                // }),
                stroke: new Stroke({
                    color: 'rgba(0, 0, 255, 1.0)',
                    width: lineWidth
                })
            }),
            minResolution: minRes,
            maxResolution: maxRes
        });

        return region;

    }
    
    function addBorder() {
        map.addLayer(region10k);
        map.addLayer(region100k);
        map.addLayer(region250k);
        map.addLayer(region1000k);
        map.addLayer(region4500k);
    }
      
      
    function removeBorder() {
        map.removeLayer(region10k);
        map.removeLayer(region100k);
        map.removeLayer(region250k);
        map.removeLayer(region1000k);
        map.removeLayer(region4500k);    
    }
      
      
    function updateCollections() {
          collections = '';
          if ($('#checkbox-1').is(':checked')) {
              fi = true;
          } else {
              fi = false;
          }
          if ($('#checkbox-2').is(':checked')) {
              no = true;
          } else {
              no = false;
          }
          if (no) { 
              collections = layerByCountry + '_NO'; 
              if (fi) {
                  collections = collections.concat(',' + layerByCountry + '_FI');
              }
          } else {
              if (fi) {
                  collections = layerByCountry + '_FI';
              }
          }
          // console.log("Collections: " + collections);
          if (collections.length > 0) {
              updateCoverageLayer();
              imageLayer.setVisible(true);
          } else {
              imageLayer.setVisible(false);
          }
    }



    $("#startDownload").on('click', function() {

        console.log("In startDownload");

    	var downloadFormat = $("#downloadFormat").val();
    	var fileExt = '';
    	if (downloadFormat == 'GTiff') { fileExt = 'tif'; }
    	if (downloadFormat == 'json') { fileExt = 'json'; }
        let currentExtent = map.getView().calculateExtent(map.getSize());
        // var targetExtent = ol.proj.transformExtent(currentExtent, 'EPSG:3857', 'EPSG:3067');
        let minx = currentExtent[0];
        let miny = currentExtent[1];
        let maxx = currentExtent[2];
        let maxy = currentExtent[3];
    	let mapsize = map.getSize();
        var width = Math.round(mapsize[0]);
        var height = Math.round(mapsize[1]);
    	var a = $("<a>")
                .attr("href", "/geoe3/" + layer + "/search?f=" + downloadFormat 
                   + "&collections=" + collections + "&subset=x(" + minx + ":" + maxx + "),y(" + miny + ":" + maxy + ")"
		     + "&scale-size=x(" + width + "),y(" + height + ")")
                .attr("download", "download." + fileExt)
                .appendTo("body");

        a[0].click();
        a.remove();
      
    });
